export default "__VITE_ASSET__DYKT7gn$__"